import React, { Component } from "react";

import { Row, Col } from "react-flexbox-grid";
import Big from "big.js";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import _ from "lodash";

import {
  Page,
  Loadable,
  DataTable,
  ViewSaleButton,
  Fab
} from "components/support";

import { colors, Icon } from "assets";
import Filter from "./filter";
import SummaryCard from "./summary-card";

import { fn } from "util";

class DevolutionReportView extends Component {
  userConfig = {
    identifier: "salesman_id",
    columns: [
      {
        accessor: "created_at",
        Header: "Data",
        type: "datetime",
        align: "center"
      },
      {
        id: "total_value",
        type: "money",
        accessor: report => report.total_value,
        Header: "Valor",
        align: "right"
      },
      {
        accessor: report => _.get(report, "credit_coupon.code"),
        id: "credit_coupon.code",
        Header: "Devolução",
        align: "center"
      },
      {
        id: "salesman.name",
        accessor: report =>
          _.get(report, "salesman.name") || "Vendedor não Identificado",
        Header: "Vendedor",
        align: "left"
      },
      {
        id: "customer.name",
        accessor: report =>
          _.get(report, "customer.name") || "Cliente não Identificado",
        Header: "Nome do Cliente",
        align: "left"
      },
      {
        id: "customer.identification",
        accessor: report => this.formatCpf(report),
        Header: "CPF/CNPj",
        align: "left"
      },
      {
        id: "sale.document.number",
        Header: "Venda Devolvida",
        Cell: props => {
          return <ViewSaleButton sale={props.original.sale} />;
        }
      }
    ]
  };
  formatCpf(value) {
    const cpf = _.get(value, "customer.identification");
    if (cpf) {
      return fn.formatToMask("XXX.XXX.XXX-XX", cpf);
    } else {
      return "-";
    }
  }

  downloadButton = () => (
    <Fab
      backgroundColor={colors.button.secondary}
      tooltip="Download"
      icon="file_download"
      options={[
        {
          backgroundColor: colors.secondary.light,
          onClick: () => this.props.presenter.onDownload("csv"),
          iconComponent: (
            <Icon.CsvFile style={{ fill: colors.secondary.dark }} />
          ),
          tooltip: "CSV"
        }
      ]}
    />
  );

  render() {
    const { presenter, viewModel } = this.props;
    const {
      loading,
      filters,
      results,
      pagination,
      order,
      summary,
      userSearchOptions,
      user,
      mode
    } = viewModel;

    return (
      <Page>
        <Typography type="display1" className="pb-sm">
          Relatório de Devoluções
        </Typography>
        <Row>
          <Col xs={12} md={8}>
            <Filter
              loading={loading}
              filters={filters}
              user={user}
              userSearchOptions={userSearchOptions}
              onSelectUser={user => presenter.onSelectUser(user)}
              onChange={filters => presenter.onFilterChange(filters)}
            />
          </Col>
          <Col xs={12} md={4}>
            <SummaryCard
              loading={loading}
              value={Big(summary.total || 0)
                .div(100)
                .toFixed(2)}
              label="Total"
            />
          </Col>
        </Row>

        <Loadable loading={loading}>
          <Paper elevation={1} style={{ marginTop: 12 }}>
            <DataTable
              manual
              defaultSorted={[{ id: "created_at", desc: true }]}
              filterable={false}
              resultSet={results}
              total={pagination.total}
              perPage={pagination.perPage}
              page={pagination.page}
              config={mode === "user" ? this.userConfig : this.saleConfig}
              onChange={({ field, value }) =>
                presenter.onOrderChange(field, value)
              }
              orderField={order.field}
              orderDirection={order.direction}
              onPageChange={page => presenter.onPageChange(page + 1)}
            />
          </Paper>
        </Loadable>

        {this.downloadButton()}
      </Page>
    );
  }
}

export default DevolutionReportView;



// WEBPACK FOOTER //
// ./src/components/app/management/devolution-report/view.jsx